var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }